import { z } from 'zod';

export const preferencesSchema = z.object({
  likedAccords: z.array(z.string()),
  dislikedNotes: z.array(z.string()),
  excludedIds: z.array(z.string()),
  likedFragranceIds: z.array(z.string()),
  season: z.enum(['any', 'spring', 'summer', 'autumn', 'winter']),
  occasion: z.enum(['any', 'everyday', 'work', 'evening', 'special']),
  intensity: z.enum(['any', 'low', 'moderate', 'high']),
  marketedGender: z.enum(['any', 'women', 'men', 'unisex']),
  exploration: z.number().min(0).max(1),
});

export type Preferences = z.infer<typeof preferencesSchema>;

export const defaultPreferences: Preferences = {
  likedAccords: [],
  dislikedNotes: [],
  excludedIds: [],
  likedFragranceIds: [],
  season: 'any',
  occasion: 'any',
  intensity: 'any',
  marketedGender: 'any',
  exploration: 0.45,
};
